import setupSentry from 'web-app/shared/sentry-setup';
import ENV from 'signin-app/config/environment';
export default () => setupSentry(ENV);
